/**
 * Admin system fully removed (2026-02).
 *
 * This file remains as a no-op stub so the dozens of user-facing pages
 * that imported `isAdmin` / `adminHeader` continue to compile without a
 * sweeping refactor. Every check now returns `false` / `{}` so any
 * `{admin && <DeleteButton />}` style blocks across the app vanish
 * gracefully — the data they used to control (threads, dossiers, war
 * rooms, etc.) stays intact, just no UI to mutate it.
 *
 * If/when admin tools are rebuilt, replace this stub with the new
 * implementation. Until then, do not import anything new from here.
 */
export const isAdmin = () => false;
export const adminHeader = () => ({});
export const getAdminCode = () => null;
export const setAdminCode = () => {};
export const clearAdminCode = () => {};
export const clearAdmin = () => {};
